module.exports = __webpack_public_path__ + "img/gift3.c34f9f8f.png";